import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import GModal from "../../design/components/GModal";
import Button from "../../design/Button";
import { formatDate } from "../../../utility-functions";
import gStyles from "../../design/commonStyles";
import {
  CustomInput,
  CustomSelect,
} from "../../design/components/customComponents";
import { errorIcon } from "../../../utility-functions/assetLoader";
import classes from "./ManageLicenseModal.module.css";

const actionOptions = [
  { value: "Add", displayValue: "Add" },
  { value: "Remove", displayValue: "Remove" },
];

const ManageLicenseModal = ({
  data,
  handleClose,
  renewalDate,
  handleRemoveLicense,
}) => {
  const navigate = useNavigate();
  const [changeType, setChangeType] = useState("Add");
  const [quantity, setQuantity] = useState({ value: "", error: null });
  const [info, setInfo] = useState({ visible: false, message: "" });

  const handleUpdate = (e) => {
    e.preventDefault();
    if (!changeType || !quantity?.value) return;
    if (quantity.value <= 0)
      setQuantity((prev) => ({ ...prev, error: "Please enter a valid value" }));
    else if (changeType === "Remove" && quantity.value > data?.licenses?.totalLicense)
      setQuantity((prev) => ({
        ...prev,
        error: "Please enter a value less than or equal to free licenses",
      }));
    else if (changeType === "Add") {
      const payload = {
        quantity: quantity.value,
        type: data?.type === "Viewer" ? "viewer" : (data?.type === "Plan" ? "plan" : "feature")
      };
      if (payload.type === "feature") {
        payload["feature_id"] = data?.featureId;
      }
      navigate("/billing/cart", { state: { payload } });
    } else if (changeType === "Remove") {
      handleRemoveLicense(quantity.value, data?.type);
      handleCloseModal();
    }
  };

  const handleCloseModal = () => {
    setChangeType("Add");
    setQuantity({ value: "", error: null });
    setInfo({ visible: false, message: "" });
    handleClose();
  };

  useEffect(() => {
    if (!quantity?.value && info.visible)
      setInfo({ visible: false, message: "" });
    if (!changeType || !quantity?.value || changeType === "Add") return;
    if (
      changeType === "Remove"
    ) {
      const removableLicenses = data.licenses.total - data.licenses.deleted;
      if (removableLicenses >= quantity?.value && quantity?.value > 0) {
      setInfo({
        visible: true,
        message: (
          <p className="t7 regular-font">
             You are reducing your license from{" "}
              <b>{removableLicenses}</b> to{" "}
              <b>{removableLicenses - quantity?.value}</b>. The changes will
              take effect from <b>{formatDate(renewalDate)}</b>. You can
              continue to use the license until then.
          </p>
        ),
      });
      } else {
        setInfo({ visible: false, message: "" });
      }
    }
  }, [changeType, quantity?.value]);

  return (
    <GModal
      bodyWrapperStyle={{ width: "470px", paddingRight: 0 }}
      visible={data?.visible}
      closeModal={handleCloseModal}
      heading={`Manage license`}
      bottomButtons={[
        <Button
          styleOverride={gStyles.btnStyle}
          hierarchy="white"
          variant="outlined"
          disabled={false}
          buttonText="Cancel"
          onClick={handleCloseModal}
        />,
        <Button
          styleOverride={gStyles.btnStyle}
          hierarchy="green"
          buttonText={changeType === "Add" ? "Next" : "Update"}
          onClick={handleUpdate}
          disabled={!changeType || !quantity.value}
        />,
      ]}
      body={
        <div>
          <CustomInput
            label="License"
            value={{ value: data?.type, error: null }}
            handleChange={() => null}
            inputProps={{ disabled: true }}
            labelStyles={{ color: "#3F3F46" }}
          />
          <label className={classes.actionLabel}>Add/remove license</label>
          <div className={classes.actionContainer}>
            <div>
              <CustomSelect
                value={changeType}
                handleChange={(e) => {
                  setChangeType(e.target.value);
                  setQuantity({ value: "", error: null });
                }}
                options={actionOptions}
                selectStyles={{
                  height: "36.5px",
                  marginTop: "3.5px",
                  minWidth: "120px",
                }}
              />
            </div>
            <CustomInput
              placeholder="Enter quantity"
              name="quantity"
              type="number"
              value={quantity}
              handleChange={(e) =>
                setQuantity((prev) => ({ ...prev, value: e.target.value }))
              }
              handleFocus={() => {
                setQuantity((prev) => ({ ...prev, error: null }));
              }}
              inputProps={{ min: 1 }}
              labelStyles={{ marginBottom: 0, width: "100%" }}
            />
          </div>
          {info?.visible && (
            <div className={classes.warning}>
              <span>{errorIcon("#3F3F46")}</span>
              {info?.message}
            </div>
          )}
        </div>
      }
    />
  );
};
export default ManageLicenseModal;
